import React from 'react';
import PropTypes from 'prop-types';
import { flowRight } from 'lodash';

import makeDataAccessHoc from '../../../data/makeDataAccessHoc';
import queryGql from '../../../data/withTenantInfo.graphql';
import withAppConfig from '../../utils/AppConfig/withAppConfig';
import { stripTrailingSlash } from '../../../utils/normalizeUrl';
import fileStorageService from '../../../data/upload/fileStorageService';

const dataHoc = makeDataAccessHoc(queryGql);

export const TenantInfoContext = React.createContext({
  tenantInfo: {
    tenantId: undefined,
    tenantLogo: undefined,
    loginBgImg: undefined,
    isAdminTenant: false,
    loginPageMessage: '',
    siteName: 'Edana',
  },
});

export const tenantInfoContextPropTypes = {
  tenantInfo: PropTypes.shape({
    tenantId: PropTypes.number,
    tenantLogo: PropTypes.string,
    isAdminTenant: PropTypes.bool,
  }).isRequired,
};

@flowRight(dataHoc(), withAppConfig)
export default class TenantInfoContextProvider extends React.PureComponent {
  static propTypes = {
    children: PropTypes.node,
    tenantInfo: PropTypes.shape({
      tenantId: PropTypes.number.isRequired,
      logoFileId: PropTypes.string,
    }).isRequired,
    ...withAppConfig.props,
  };
  static defaultProps = {
    children: null,
  };

  get apiUrl() {
    const { appConfig } = this.props;

    return stripTrailingSlash(appConfig.fileStorageApiUrl);
  }

  get tenantLogo() {
    const {
      tenantInfo: { logoFileId, tenantId },
    } = this.props;

    let logoSrc = undefined;
    if (logoFileId) {
      logoSrc = fileStorageService(this.apiUrl).getFileUrl({
        fileId: logoFileId,
        tenantId,
      });
    }
    return logoSrc;
  }

  get loginBackground() {
    const {
      tenantInfo: { loginBgImgId, tenantId },
    } = this.props;

    let loginBgImgSrc = undefined;
    if (loginBgImgId) {
      loginBgImgSrc = fileStorageService(this.apiUrl).getFileUrl({
        fileId: loginBgImgId,
        tenantId,
      });
    }
    return loginBgImgSrc;
  }

  render() {
    const {
      children,
      tenantInfo: { tenantId, isAdminTenant, loginPageMessage, siteName },
    } = this.props;

    return (
      <TenantInfoContext.Provider
        value={{
          tenantId,
          tenantLogo: this.tenantLogo,
          loginBgImg: this.loginBackground,
          isAdminTenant,
          loginPageMessage,
          siteName,
        }}
      >
        {children}
      </TenantInfoContext.Provider>
    );
  }
}
